
import './App.css';

// import About from './About';
import Navbar from './components/Navbar'
import TextForms from './components/TextForms';

function App() {
  
  return (
    <>
      {/* <Navbar tittle = "STech" selector1 = "Home"/> */}
      <Navbar/>
      <div className="container my-3">
      <TextForms heading = "Enter the text to analyze"/>
      
      {/* <About/> */}

      </div>

      {/* <div className="container">
      <br/> <br/>
            <img />Design and Developed by <a href="https://suryaportfolio1.netlify.app/"> STech</a>
            <br/>
      </div> */}
    </>
  );
}

export default App;
